import { NgClass, NgIf } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { MatBadge } from "@angular/material/badge";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuTrigger } from "@angular/material/menu";
import { NotificationService } from "src/app/shared/services/notification.service";
import { Notification } from "../../models/notification.model";
import { NotificationsComponent } from "./notifications/notifications.component";

@Component({
    selector: "app-notification-menu",
    templateUrl: "./notification-menu.component.html",
    styleUrls: ["./notification-menu.component.scss"],
    imports: [
        MatIconButton,
        MatMenuTrigger,
        MatIcon,
        NgClass,
        ExtendedModule,
        MatBadge,
        MatMenu,
        NgIf,
        NotificationsComponent,
    ]
})
export class NotificationMenuComponent implements OnInit {
  notificationsCount: string | null = null;
  @Input() notifications: Notification[];

  constructor(public notificationService: NotificationService) {}

  ngOnInit(): void {
    //TODO: check whether user has notifications and update this flag value
    this.notificationsCount = this.getNotificationsCount();
  }

  getNotificationsCount(): string | null {
    let count = this.notifications?.length;
    let unread = this.notifications?.filter(
      (n) => n.isUnread && this.notificationService.checkTime(n.notificationDate)
    ).length;
    return unread > 99 ? "99+" : count > 0 ? unread?.toString() : null;
  }

  unreadToggle(event: Event) {
    event.stopPropagation();
    switch (event.target["checked"]) {
      case true:
        this.notifications = this.notifications?.filter((item) => item.isUnread);
        break;
      case false:
        this.notificationService.getNotifications().subscribe((r) => (this.notifications = r));
        break;
    }
  }

  markAllRead(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.notifications.forEach((item) => {
      this.notificationService
        .updateNotification(item.notificationId, {
          isUnread: false,
          notificationDate: item.notificationDate,
        })
        .subscribe();
    });
  }
}
